import { Link } from "react-router-dom";
import { getMangaBySlug } from "@/mocks/comics";

export default function CompletionBanner() {
  const featured = getMangaBySlug("qingmei");

  return (
    <section className="container-site py-12 md:py-16" aria-labelledby="completion-title">
      <div className="relative overflow-hidden rounded-lg">
        <img
          src="https://readdy.ai/api/search-image?query=romantic%20anime%20illustration%20of%20a%20couple%20embracing%20in%20front%20of%20a%20sparkling%20wedding%20arch%20decorated%20with%20peach%20roses%2C%20golden%20bokeh%20lights%20and%20floating%20flower%20petals%2C%20warm%20sunset%20glow%2C%20soft%20pastel%20coral%20and%20gold%20palette%2C%20stylized%20shoujo%20manga%20art%2C%20wide%20banner%20composition%2C%20dreamy%20happy%20ending%20atmosphere%2C%20no%20text&width=1600&height=720&seq=banner-completion-89890&orientation=landscape"
          alt="完结大结局 免费畅读 横幅"
          title="青梅竹马不断向我甜蜜求婚 大结局免费阅读"
          className="absolute inset-0 h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/65 via-black/45 to-black/20" />

        <div className="relative z-10 flex w-full flex-col items-start gap-4 p-8 md:p-12 lg:p-16">
          <span className="chip-tag !bg-accent-500 !text-background-50">
            <i className="ri-flag-2-fill text-xs" aria-hidden="true" />
            完结作品 · 大结局已上线
          </span>
          <h2 id="completion-title" className="max-w-xl font-heading text-2xl font-bold leading-snug text-white md:text-4xl">
            《{featured?.title}》<br />
            完整结局，一次性免费畅读
          </h2>
          <p className="max-w-lg text-sm leading-relaxed text-white/85 md:text-base">
            从儿时约定到甜蜜求婚，全 12 话完整章节在线可读。别再苦等更新，今天就把大结局一口气看完。
          </p>
          <div className="mt-2 flex flex-col gap-3 sm:flex-row">
            <Link to="/article/qingmei?ch=ch-end" className="btn-primary !px-6 !py-3">
              <i className="ri-play-fill text-lg" aria-hidden="true" />
              开始阅读大结局
            </Link>
            <Link
              to="/category/complete"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-white/40 bg-white/10 px-6 py-3 text-sm font-medium text-white backdrop-blur-sm transition-colors hover:bg-white/20 cursor-pointer"
            >
              更多完结作品
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}